import Translations from '../Translations';
import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {choosePaymentMethod} from '../../api/selectiongql';
import {normalizePaymentMethod} from '../../utils/payment';
import ModalCompleteWarning from '../modal/completewarning';
import PaymentMethod from './method';
import PaymentSummary from './summary';

const PaymentSection = ({
    config,
    total,
    products,
    coverages,
    leaveBarter,
    onCheckout,
    onCheckoutCompleted,
    isSelectionCheckedOut,
}) => {
    const [paymentMethod, setPaymentMethod] = useState(normalizePaymentMethod(config.paymentMethod));
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setPaymentMethod(normalizePaymentMethod(config.paymentMethod));
    }, [config.paymentMethod]);

    const updatePaymentMethod = async (method) => {
        if (saving || method === paymentMethod) return;
        setSaving(true);
        try {
            const result = await choosePaymentMethod({method, token: config.token});
            if (result instanceof Error || result === false) throw new Error('Payment method was not updated.');
            setPaymentMethod(method);
        } catch (error) {
            toast.error(<Translations text="selection.payment_method_update_error" backup={"Payment method was not updated. Please try again."} />);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <PaymentMethod value={paymentMethod} disabled={saving || isSelectionCheckedOut} onChange={updatePaymentMethod} />
            <ModalCompleteWarning
                disabled={saving}
                isAllowUserCheckout={config.isAllowUserCheckout}
                onCheckout={onCheckout}
                onCheckoutCompleted={onCheckoutCompleted}
            />
            <PaymentSummary
                total={total}
                startingBalance={config.account.balance}
                paymentMethod={paymentMethod}
                currencyMinorUnit={config.currencyMinorUnit}
                currency={config.showBaseCurrency ? config.currency : ''}
                products={products}
                coverages={coverages}
                leaveBarter={leaveBarter}
            />
        </>
    );
};

export default PaymentSection;
